import {
  format,
  isToday,
  isTomorrow,
  isBefore,
  startOfDay,
  addDays,
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInCalendarDays,
  differenceInCalendarMonths,
  differenceInCalendarYears,
} from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function formatNotificationTime(date: Date | string | undefined, now: Date = new Date()): string {
  if (!date) return ''
  const d = typeof date === 'string' ? new Date(date) : date
  if (isNaN(d.getTime())) return ''

  const seconds = differenceInSeconds(now, d)
  if (seconds >= 0 && seconds < 60) return `há ${Math.max(seconds, 0)}s`

  const minutes = differenceInMinutes(now, d)
  if (minutes >= 1 && minutes < 60) return `há ${minutes} min`

  const sameDay =
    now.getFullYear() === d.getFullYear() && now.getMonth() === d.getMonth() && now.getDate() === d.getDate()

  const hours = differenceInHours(now, d)
  if (hours >= 1 && hours < 24 && sameDay) return `há ${hours} h`

  const days = differenceInCalendarDays(now, d)
  if (days === 1) return 'Ontem'
  if (days >= 2 && days <= 7) return `há ${days} dias`
  if (days >= 8 && days <= 21) {
    const weeks = Math.floor(days / 7)
    return weeks === 1 ? 'há 1 semana' : `há ${weeks} semanas`
  }

  const months = differenceInCalendarMonths(now, d)
  if (months === 1) return 'há 1 mês'
  if (months > 1 && months < 12) return `há ${months} meses`

  const years = differenceInCalendarYears(now, d)
  if (years === 1) return 'há 1 ano'
  if (years > 1) return `há ${years} anos`

  return ''
}

export function formatDate(date: Date | undefined): string {
  if (!date) return ''
  if (isToday(date)) return 'Hoje'
  if (isTomorrow(date)) return 'Amanhã'
  return format(date, "d 'de' MMMM", { locale: ptBR })
}

export function isDateDisabled(date: Date): boolean {
  return isBefore(date, startOfDay(new Date()))
}

export function formatDateParam(date: Date | undefined): string {
  if (!date) return ''
  return format(date, 'yyyy-MM-dd')
}

export function isPrevDayDisabled(date: Date | undefined): boolean {
  const reference = date ? startOfDay(date) : startOfDay(new Date())
  const prevDay = addDays(reference, -1)
  return isBefore(prevDay, startOfDay(new Date()))
}

